import { render } from "./SmartphoneWhite.vue?vue&type=template&id=b71ef8aa&scoped=true"
const script = {}

import "./SmartphoneWhite.vue?vue&type=style&index=0&id=b71ef8aa&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-b71ef8aa"

export default script